import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import { ConsultaSeguimentoPergunta06Model } from './model-consultaSeguimentoPergunta06'

export const convertConsultaSeguimentoPergunta06ToInput = (
  value: ConsultaSeguimentoPergunta06Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_06_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_06_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_06_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_06_PEGAR?.TENTA_ALCANCAR),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_06_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_06_PEGAR?.LEVA_ATE),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_06_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_06_PEGAR?.TENTA_PEGAR),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_06_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_06_PEGAR?.PEDE),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_06_06,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_06_APONTAR_PARA),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
